import type { InviteResult } from '@opti-sea/core';
import { useTranslation } from 'react-i18next';

/** What happened to the invitation email, and whether the account is new. */
export function useInviteText(): (result: InviteResult, email: string) => string {
  const { t } = useTranslation('dashboard');
  return (result, email) =>
    [
      result.email === 'sent'
        ? t('invite.emailSent', { email })
        : result.email === 'not_configured'
          ? t('invite.emailNotConfigured', { email })
          : t('invite.emailFailed', { email }),
      result.newAccount ? t('invite.newAccount') : '',
    ]
      .filter((line) => line !== '')
      .join(' ');
}
